// extracted by mini-css-extract-plugin
module.exports = {"packageList":"PackageList_packageList___9xJG"};